<template>
  <div>
    <PCNavbar />
    <MobileNavBar />
    <div class="distributor-map-container">
    <div class="page-header">
      <h1 class="page-title">全国分销商网络</h1>
      <p class="page-subtitle">覆盖全国主要城市，为您提供专业的纹发设备和服务</p>
    </div>

    <!-- 统计信息 -->
    <div class="statistics-section">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="el-icon-location"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ totalDistributors }}</div>
          <div class="stat-label">分销商总数</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon province">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ provinceDistributors }}</div>
          <div class="stat-label">省代</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon city">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ cityDistributors }}</div>
          <div class="stat-label">市代</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon county">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ countyDistributors }}</div>
          <div class="stat-label">县代</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon franchise">
          <i class="el-icon-s-shop"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ franchiseDistributors }}</div>
          <div class="stat-label">加盟店</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon experience">
          <i class="el-icon-s-home"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ experienceDistributors }}</div>
          <div class="stat-label">体验馆</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon company">
          <i class="el-icon-s-flag"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ companyDistributors }}</div>
          <div class="stat-label">公司</div>
        </div>
      </div>
    </div>

    <!-- 地图展示 -->
    <div class="map-section">
      <div class="map-container" ref="mapContainer"></div>
      
      <!-- 分销商列表 -->
      <div class="distributor-list">
        <div class="list-header">
          <h3>分销商列表</h3>
          <el-input
            v-model="searchKeyword"
            placeholder="搜索分销商"
            prefix-icon="el-icon-search"
            clearable
            @input="handleSearch"
          />
        </div>
        <div class="list-content">
          <div
            v-for="distributor in paginatedDistributors"
            :key="distributor.id"
            class="distributor-item"
            @click="handleDistributorClick(distributor)"
          >
            <div class="distributor-header">
              <h4>{{ distributor.name }}</h4>
              <el-tag
                :type="getLevelTagType(distributor.level)"
                size="small"
              >
                {{ distributor.level }}
              </el-tag>
            </div>
            <div class="distributor-info">
              <p><i class="el-icon-location-outline"></i> {{ distributor.province }} {{ distributor.city }}</p>
              <p v-if="distributor.contactPhone"><i class="el-icon-phone"></i> {{ distributor.contactPhone }}</p>
            </div>
          </div>
        </div>
        <div class="list-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :total="filteredDistributors.length"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </div>

    <!-- 分销商详情对话框 -->
    <el-dialog
      :visible.sync="detailDialogVisible"
      :title="selectedDistributor?.name"
      width="600px"
    >
      <div v-if="selectedDistributor" class="distributor-detail">
        <div class="detail-section">
          <h4>基本信息</h4>
          <div class="detail-item">
            <label>等级：</label>
            <el-tag :type="getLevelTagType(selectedDistributor.level)">
              {{ selectedDistributor.level }}
            </el-tag>
          </div>
          <div class="detail-item">
            <label>地址：</label>
            <span>{{ selectedDistributor.province }} {{ selectedDistributor.city }} {{ selectedDistributor.district }} {{ selectedDistributor.address }}</span>
          </div>
          <div class="detail-item" v-if="selectedDistributor.contactPerson">
            <label>联系人：</label>
            <span>{{ selectedDistributor.contactPerson }}</span>
          </div>
          <div class="detail-item" v-if="selectedDistributor.contactPhone">
            <label>联系电话：</label>
            <span>{{ selectedDistributor.contactPhone }}</span>
          </div>
          <div class="detail-item" v-if="selectedDistributor.contactEmail">
            <label>联系邮箱：</label>
            <span>{{ selectedDistributor.contactEmail }}</span>
          </div>
        </div>
        
        <div class="detail-section" v-if="selectedDistributor.businessScope">
          <h4>经营范围</h4>
          <p>{{ selectedDistributor.businessScope }}</p>
        </div>
        
        <div class="detail-section" v-if="selectedDistributor.description">
          <h4>分销商简介</h4>
          <p>{{ selectedDistributor.description }}</p>
        </div>
        
        <div class="detail-section" v-if="selectedDistributor.images">
          <h4>图片展示</h4>
          <div class="image-gallery">
            <img
              v-for="(img, index) in selectedDistributor.images.split(',')"
              :key="index"
              :src="img"
              alt="分销商图片"
            />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { getEnabledDistributors, getLevelStatistics } from '@/api/distributor'
import * as echarts from 'echarts'
import chinaJson from '@/assets/china.json'
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'

export default {
  name: 'Distributor',
  components: {
    PCNavbar,
    MobileNavBar
  },
  data() {
    return {
      distributors: [],
      filteredDistributors: [],
      searchKeyword: '',
      totalDistributors: 0,
      provinceDistributors: 0,
      cityDistributors: 0,
      countyDistributors: 0,
      franchiseDistributors: 0,
      experienceDistributors: 0,
      companyDistributors: 0,
      mapChart: null,
      detailDialogVisible: false,
      selectedDistributor: null,
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    paginatedDistributors() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredDistributors.slice(start, end)
    }
  },
  mounted() {
    this.loadDistributors()
    this.loadStatistics()
  },
  beforeDestroy() {
    if (this.mapChart) {
      this.mapChart.dispose()
    }
  },
  methods: {
    async loadDistributors() {
      try {
        console.log('开始加载分销商数据...')
        const res = await getEnabledDistributors()
        console.log('API响应:', res)
        
        // 后端返回格式: {data: {code: 200, msg: 'success', data: [...]}}
        if (res && res.data && res.data.data) {
          console.log('分销商数据:', res.data.data)
          this.distributors = res.data.data
          this.filteredDistributors = res.data.data
          this.totalDistributors = res.data.data.length
          console.log('加载成功，共', this.totalDistributors, '个分销商')
          this.initMap()
        } else {
          console.warn('响应数据为空')
          this.$message.warning('暂无分销商数据')
        }
      } catch (error) {
        console.error('加载分销商数据失败:', error)
        console.error('错误详情:', error.response || error.message)
        this.$message.error('加载分销商数据失败: ' + (error.message || '未知错误'))
      }
    },
    
    async loadStatistics() {
      try {
        const res = await getLevelStatistics()
        // 后端返回格式: {data: {code: 200, msg: 'success', data: {...}}}
        if (res && res.data && res.data.data) {
          this.provinceDistributors = res.data.data['省代'] || 0
          this.cityDistributors = res.data.data['市代'] || 0
          this.countyDistributors = res.data.data['县代'] || 0
          this.franchiseDistributors = res.data.data['加盟店'] || 0
          this.experienceDistributors = res.data.data['体验馆'] || 0
          this.companyDistributors = res.data.data['公司'] || 0
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
      }
    },
    
    initMap() {
      if (!this.$refs.mapContainer) return
      
      try {
        // 注册中国地图
        echarts.registerMap('china', chinaJson)
        
        this.mapChart = echarts.init(this.$refs.mapContainer)
        
        // 准备地图数据
        const mapData = this.distributors
          .filter(d => d.longitude && d.latitude)
          .map(d => ({
            name: d.city,
            value: [d.longitude, d.latitude, 1],
            distributor: d
          }))
        
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: (params) => {
              if (params.data && params.data.distributor) {
                const d = params.data.distributor
                return `
                  <div style="padding: 10px;">
                    <h4 style="margin: 0 0 10px 0;">${d.name}</h4>
                    <p style="margin: 5px 0;"><strong>等级：</strong>${d.level}</p>
                    <p style="margin: 5px 0;"><strong>地址：</strong>${d.province} ${d.city}</p>
                    ${d.contactPhone ? `<p style="margin: 5px 0;"><strong>电话：</strong>${d.contactPhone}</p>` : ''}
                  </div>
                `
              }
              return params.name
            }
          },
          geo: {
            map: 'china',
            roam: true,
            label: {
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#f3f3f3',
                borderColor: '#516b91'
              },
              emphasis: {
                areaColor: '#ffd700'
              }
            }
          },
          series: [
            {
              name: '分销商',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: mapData,
              symbolSize: 8,
              label: {
                formatter: '{b}',
                position: 'right',
                show: false,
                color: '#fff',
                fontSize: 12,
                fontWeight: 'bold'
              },
              itemStyle: {
                color: (params) => {
                  const level = params.data.distributor.level
                  if (level === '省代') return '#FF4500'
                  if (level === '市代') return '#1E90FF'
                  if (level === '县代') return '#32CD32'
                  if (level === '加盟店') return '#FFD700'
                  if (level === '体验馆') return '#FF69B4'
                  if (level === '公司') return '#8A2BE2'
                  return '#409eff'
                },
                shadowBlur: 10,
                shadowColor: (params) => {
                  const level = params.data.distributor.level
                  if (level === '省代') return '#FF4500'
                  if (level === '市代') return '#1E90FF'
                  if (level === '县代') return '#32CD32'
                  if (level === '加盟店') return '#FFD700'
                  if (level === '体验馆') return '#FF69B4'
                  if (level === '公司') return '#8A2BE2'
                  return '#409eff'
                }
              },
              emphasis: {
                label: {
                  show: true
                },
                itemStyle: {
                  shadowBlur: 20,
                  shadowColor: '#fff'
                }
              }
            }
          ]
        }
        
        this.mapChart.setOption(option)
        
        // 点击事件
        this.mapChart.on('click', (params) => {
          if (params.data && params.data.distributor) {
            this.handleDistributorClick(params.data.distributor)
          }
        })
        
        // 响应式
        window.addEventListener('resize', () => {
          if (this.mapChart) {
            this.mapChart.resize()
          }
        })
      } catch (error) {
        console.error('初始化地图失败:', error)
        this.$message.error('地图初始化失败')
      }
    },
    
    handleSearch() {
      if (!this.searchKeyword) {
        this.filteredDistributors = this.distributors
      } else {
        const keyword = this.searchKeyword.toLowerCase()
        this.filteredDistributors = this.distributors.filter(d =>
          d.name.toLowerCase().includes(keyword) ||
          d.province.toLowerCase().includes(keyword) ||
          d.city.toLowerCase().includes(keyword)
        )
      }
      this.currentPage = 1
    },
    
    handlePageChange(page) {
      this.currentPage = page
    },
    
    handleDistributorClick(distributor) {
      this.selectedDistributor = distributor
      this.detailDialogVisible = true
    },
    
    getLevelTagType(level) {
      if (level === '省代') return 'danger'
      if (level === '市代') return 'primary'
      if (level === '县代') return 'success'
      if (level === '加盟店') return 'warning'
      if (level === '体验馆') return ''
      if (level === '公司') return 'info'
      return ''
    }
  }
}
</script>

<style scoped>
.distributor-map-container {
  padding: 100px 20px 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.page-subtitle {
  font-size: 16px;
  color: #666;
}

.statistics-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-right: 20px;
}

.stat-icon.province {
  background: linear-gradient(135deg, #FF4500, #FF6347);
}

.stat-icon.city {
  background: linear-gradient(135deg, #1E90FF, #4169E1);
}

.stat-icon.county {
  background: linear-gradient(135deg, #32CD32, #228B22);
}

.stat-icon.franchise {
  background: linear-gradient(135deg, #FFD700, #FFA500);
}

.stat-icon.experience {
  background: linear-gradient(135deg, #FF69B4, #FF1493);
}

.stat-icon.company {
  background: linear-gradient(135deg, #8A2BE2, #9370DB);
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #333;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}

.map-section {
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 20px;
  min-height: 600px;
}

.map-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  height: 600px;
}

.distributor-list {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 600px;
}

.list-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.list-header h3 {
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #333;
}

.list-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.distributor-item {
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #eee;
}

.distributor-item:hover {
  background: #f5f7fa;
  border-color: #409eff;
}

.distributor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.distributor-header h4 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.distributor-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
}

.distributor-info i {
  margin-right: 5px;
}

.list-pagination {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
}

.distributor-detail {
  padding: 10px;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section h4 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
  border-bottom: 2px solid #409eff;
  padding-bottom: 8px;
}

.detail-item {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
}

.detail-item label {
  font-weight: bold;
  color: #666;
  min-width: 80px;
  margin-right: 10px;
}

.detail-item span {
  color: #333;
  flex: 1;
}

.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}

.image-gallery img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
}

@media (max-width: 1024px) {
  .map-section {
    grid-template-columns: 1fr;
  }
  
  .distributor-list {
    height: 400px;
  }
}
</style>
